export enum CheckboxState {
    Checked = 'checked',
    Indeterminate = 'indeterminate',
    NotChecked = 'notChecked'
}